import React from "react";
import { useNavigate } from "react-router-dom";
import {
  RankingMontagemProvider,
  useRankingMontagem,
} from "./context/RankingMontagemContext";
import { RankingMontagemView } from "./components/RankingMontagemView";

const RankingMontagemContent: React.FC = () => {
  const navigate = useNavigate();
  const {
    montadores,
    dailyStats,
    lojas,
    isLoading,
    selectedLojaId,
    showLojaSelector,
    dateLabel,
    selectedLojaNome,
    toggleLojaSelector,
    selectAllLojas,
    selectLoja,
  } = useRankingMontagem();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-red-900 text-white">
        <div className="text-center">
          <p className="text-xl">Carregando ranking...</p>
        </div>
      </div>
    );
  }

  return (
    <RankingMontagemView
      montadores={montadores}
      dailyStats={dailyStats}
      lojas={lojas}
      selectedLojaId={selectedLojaId}
      showLojaSelector={showLojaSelector}
      dateLabel={dateLabel}
      selectedLojaNome={selectedLojaNome}
      onGoHome={() => navigate("/dashboard")}
      onToggleLojaSelector={toggleLojaSelector}
      onSelectAllLojas={selectAllLojas}
      onSelectLoja={selectLoja}
    />
  );
};

const RankingMontagemPage: React.FC = () => {
  return (
    <RankingMontagemProvider>
      <RankingMontagemContent />
    </RankingMontagemProvider>
  );
};

export default RankingMontagemPage;
export { RankingMontagemView } from "./components/RankingMontagemView";
export type { RankingMontagemViewProps } from "./types";
